export default {"src":"/_next/static/media/input-reset.e57a7ace.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};